<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="(val) => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/school-dashboard"
        class="d-flex align-center text-decoration-none"
        @click.native="reloadPage"
      >
        <v-img
          :src="require('@/assets/images/logos/logo_4_small_bustracker.png')"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          eager
          class="app-logo me-3"
        ></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            {{ systemName }}
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

    <!-- Navigation Items -->
    <v-list expand shaped class="vertical-nav-menu-items pr-5 nav-list-bottom">
      <nav-menu-link
        :title="$t('sidebar.dashboard')"
        :to="{ name: 'school-dashboard' }"
        :icon="icons.mdiHomeOutline"
        color="#e65100"
      ></nav-menu-link>

      <nav-menu-group
        :title="$t('sidebar.users')"
        icon="mdi-account-multiple-outline"
        :hapur="eHapur('users')"
        @hapje="ndrysho('users', $event)"
      >
        <nav-menu-link
          :title="$t('sidebar.students')"
          :to="{ name: 'students' }"
          icon="mdi-badge-account-outline"
          color="#F57C00"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.absences')"
          :to="{ name: 'school-absences' }"
          icon="mdi-calendar-remove-outline"
          color="#C62828"
        ></nav-menu-link>
        <nav-menu-link
          v-if="etiketatNdezur"
          :title="$t('sidebar.tags')"
          :to="{ name: 'school-student-tags' }"
          icon="mdi-bluetooth"
          color="#00838F"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.guardians')"
          :to="{ name: 'guardians' }"
          icon="mdi-account-group-outline"
          color="#7B1FA2"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.drivers')"
          :to="{ name: 'drivers' }"
          icon="mdi-account-tie-hat"
          color="#1976D2"
        ></nav-menu-link>
      </nav-menu-group>

      <nav-menu-group
        :title="$t('sidebar.system_setup')"
        icon="mdi-cog-outline"
        :hapur="eHapur('setup')"
        @hapje="ndrysho('setup', $event)"
      >
        <nav-menu-link
          :title="$t('sidebar.schools')"
          :to="{ name: 'schools' }"
          icon="mdi-school"
          color="#1976D2"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.classes')"
          :to="{ name: 'classes' }"
          icon="mdi-google-classroom"
          color="#388E3C"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.buses')"
          :to="{ name: 'buses' }"
          icon="mdi-bus-multiple"
          color="#e65100"
        ></nav-menu-link>
      </nav-menu-group>

      <!-- Jashte grupeve me qellim: perdoret cdo dite. -->
      <nav-menu-link
        :title="$t('sidebar.live_tracking')"
        :to="{ name: 'live-tracking' }"
        icon="mdi-crosshairs-gps"
        color="#e65100"
      ></nav-menu-link>

      <nav-menu-group
        :title="$t('sidebar.reports')"
        icon="mdi-chart-box-outline"
        :hapur="eHapur('reports')"
        @hapje="ndrysho('reports', $event)"
      >
        <nav-menu-link
          :title="$t('sidebar.bus_reports')"
          :to="{ name: 'school-reports' }"
          icon="mdi-bus-clock"
          color="#F57C00"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.ride_history')"
          :to="{ name: 'school-ride-history' }"
          icon="mdi-map-marker-path"
          color="#00897B"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.student_reports')"
          :to="{ name: 'school-student-reports' }"
          icon="mdi-account-clock-outline"
          color="#1976D2"
        ></nav-menu-link>
      </nav-menu-group>

      <nav-menu-group
        :title="$t('sidebar.general')"
        icon="mdi-dots-horizontal-circle-outline"
        :hapur="eHapur('general')"
        @hapje="ndrysho('general', $event)"
      >
        <!-- 'school-payments-1' eshte faqja e pagesave te nxenesve.
             'school-payments' pa prapashtese eshte faqja e planeve — emra te
             ngjashem per dy faqe krejt te ndryshme. -->
        <nav-menu-link
          :title="$t('sidebar.payments')"
          :to="{ name: 'school-payments-1' }"
          icon="mdi-credit-card-multiple-outline"
          color="#388E3C"
        ></nav-menu-link>
        <nav-menu-link
          :title="$t('sidebar.notifications')"
          :to="{ name: 'school-notifications' }"
          icon="mdi-bell-outline"
          color="#7B1FA2"
        ></nav-menu-link>
      </nav-menu-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiMapMarkerPath,
  mdiCrosshairsGps,
} from '@mdi/js';
import axios from 'axios';
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue';
import NavMenuGroup from './components/NavMenuGroup.vue';
import NavMenuLink from './components/NavMenuLink.vue';
import { Keys } from '/src/config.js';
import auth from '@/services/AuthService';

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
    Keys,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiMapMarkerPath,
        mdiCrosshairsGps,
      },
      systemName: Keys.VUE_APP_SYSTEM_NAME,
    };
  },
  data() {
    return {
      mode: null,
      // Grupi i hapur me dore. Ai ku ndodhet faqja aktuale hapet gjithsesi.
      grupiIHapur: localStorage.getItem('navGroup') || null,
      // Moduli i etiketave e ndez admini i platformes, per shkolle.
      etiketatNdezur: false,
    };
  },
  computed: {
    /** Ne cilin grup bie faqja aktuale. */
    grupiAktiv() {
      const emri = this.$route.name || '';

      if (['students', 'school-absences', 'school-student-tags', 'guardians', 'drivers'].includes(emri)) return 'users';
      if (['schools', 'classes', 'buses'].includes(emri)) return 'setup';
      if (['school-reports', 'school-ride-history', 'school-student-reports'].includes(emri)) return 'reports';
      if (['school-payments-1', 'school-payments', 'school-notifications'].includes(emri)) return 'general';

      return null;
    },
  },
  mounted() {
    this.mode = auth.getMode();
    this.merrModulin();
  },
  methods: {
    async merrModulin() {
      try {
        const { data } = await axios.get('/student-tags/module');
        this.etiketatNdezur = !!data.enabled;
      } catch (e) {
        // Pa pergjigje zeri mbetet i fshehur: me mire te mungoje sesa te
        // çoje te nje faqe qe nuk punon.
        this.etiketatNdezur = false;
      }
    },

    /**
     * Grupi hapet nese aty ndodhet faqja aktuale, ose nese perdoruesi e hapi
     * vete heren e fundit. Keshtu nuk humbet vendi ku je dhe nuk duhen dy
     * klikime per te pare se ku ndodhesh.
     */
    eHapur(celesi) {
      return this.grupiAktiv === celesi || this.grupiIHapur === celesi;
    },

    ndrysho(celesi, hapur) {
      this.grupiIHapur = hapur ? celesi : null;

      if (hapur) {
        localStorage.setItem('navGroup', celesi);
      } else {
        localStorage.removeItem('navGroup');
      }
    },

    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.nav-list-bottom {
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
}
</style>
